import { render, staticRenderFns } from "./TourWorldMapPollstar.vue?vue&type=template&id=80eaf6b2&scoped=true&"
import script from "./TourWorldMapPollstar.vue?vue&type=script&lang=js&"
export * from "./TourWorldMapPollstar.vue?vue&type=script&lang=js&"
import style0 from "./TourWorldMapPollstar.vue?vue&type=style&index=0&id=80eaf6b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80eaf6b2",
  null
  
)

export default component.exports